"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataDefToColumns = exports.routesFromPrefix = void 0;

var react_1 = __importDefault(require("react"));

var react_router_dom_1 = require("react-router-dom");

var Search_1 = __importDefault(require("@material-ui/icons/Search"));

var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));

var utils_1 = require("./pre/utils");

function linkDetailColumn(urlPrefix, detailUrlPrefix) {
  var finalUrlPrefix = urlPrefix + (detailUrlPrefix ? "/".concat(detailUrlPrefix) : '');
  return {
    name: 'id',
    label: 'Action',
    render: function DetailColumn(x) {
      var id = 0;

      if (x.uuid) {
        id = x.uuid;
      } else {
        if (x.id) id = x.id;
      }

      return react_1.default.createElement(react_router_dom_1.Link, {
        to: "".concat(finalUrlPrefix, "/").concat(id, "/detail")
      }, react_1.default.createElement(IconButton_1.default, null, react_1.default.createElement(Search_1.default, {
        color: "primary"
      })));
    }
  };
}

var stackDetailColumn = function stackDetailColumn(selectRow) {
  return {
    name: 'id',
    label: 'Action',
    render: function DetailColumn(x) {
      var id = 0;

      if (x.uuid) {
        id = x.uuid;
      } else {
        if (x.id) id = x.id;
      }

      return react_1.default.createElement(IconButton_1.default, {
        color: "primary",
        onClick: function onClick() {
          return selectRow(id);
        }
      }, react_1.default.createElement(Search_1.default, null));
    }
  };
};

exports.routesFromPrefix = function (detailUrlPrefix) {
  var addAndDetailPrefix = '/' + (detailUrlPrefix ? "".concat(detailUrlPrefix, "/") : '');
  return {
    add: "".concat(addAndDetailPrefix, "add"),
    detail: "".concat(addAndDetailPrefix, ":uuid")
  };
};

exports.dataDefToColumns = function (dd, selectRow) {
  var urlPrefix = dd.urlPrefix,
      fields = dd.fields,
      detailUrlPrefix = dd.detailUrlPrefix,
      detailPage = dd.detailPage;
  var d = fields.filter(function (x) {
    if (typeof x.hideInList !== 'undefined') {
      console.warn("Usage of 'hideInList' are deprecated and won't be supported in the future. Please use 'hide: { list: true }' instead.");
    }

    return utils_1.shouldShowFieldInList(x);
  }).map(function (x) {
    return {
      name: x.name,
      label: x.label || x.name,
      options: x.options,
      render: x.render,
      filter: x.filter,
      sort: x.sort
    };
  });

  if (detailPage === 'stack' && selectRow) {
    d.push(stackDetailColumn(selectRow));
  } else {
    d.push(linkDetailColumn(urlPrefix, detailUrlPrefix));
  }

  return d;
};